import React from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Heart, Pencil, Trash2, ThumbsUp } from 'lucide-react';

export function GratitudeTab({
  gratitudes, gratitudeInput, setGratitudeInput,
  editingGratitude, setEditingGratitude,
  onCreate, onEdit, onDelete,
}) {
  return (
    <>
      <Card className="bg-slate-800 border-slate-700 mb-6">
        <CardContent className="p-4">
          <div className="flex gap-3">
            <textarea
              value={gratitudeInput}
              onChange={(e) => setGratitudeInput(e.target.value)}
              placeholder={editingGratitude ? "Edit your gratitude..." : "What are you grateful for today?"}
              className="flex-1 bg-slate-900 border border-slate-600 rounded-md p-3 text-white resize-none"
              rows={2}
              data-testid="gratitude-input"
            />
            <div className="flex flex-col gap-1">
              <Button
                onClick={onCreate}
                disabled={!gratitudeInput.trim()}
                className={editingGratitude ? "bg-blue-600 hover:bg-blue-700" : "bg-pink-600 hover:bg-pink-700"}
                data-testid="submit-gratitude-btn"
              >
                {editingGratitude ? <Pencil className="h-4 w-4" /> : <Heart className="h-4 w-4" />}
              </Button>
              {editingGratitude && (
                <Button variant="outline" size="sm" onClick={() => { setEditingGratitude(null); setGratitudeInput(''); }} className="text-xs">
                  Cancel
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="space-y-3">
        {gratitudes.length === 0 ? (
          <Card className="bg-slate-800 border-slate-700">
            <CardContent className="p-8 text-center">
              <Heart className="h-12 w-12 text-slate-600 mx-auto mb-4" />
              <p className="text-slate-400">Share what you're grateful for!</p>
            </CardContent>
          </Card>
        ) : gratitudes.map(g => (
          <Card key={g.gratitude_id} className="bg-slate-800 border-slate-700">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <Heart className="h-5 w-5 text-pink-500 mt-1 flex-shrink-0" />
                <div className="flex-1">
                  <p className="text-slate-300">{g.content}</p>
                  <p className="text-sm text-slate-500 mt-2">{g.user_name} • {new Date(g.created_at).toLocaleDateString()}</p>
                </div>
                <Badge variant="outline" className="text-pink-400 border-pink-400/30">
                  <ThumbsUp className="h-3 w-3 mr-1" /> {g.likes || 0}
                </Badge>
              </div>
              <div className="flex items-center gap-2 mt-3 pt-3 border-t border-slate-700">
                <Button variant="ghost" size="sm" onClick={() => onEdit(g)} className="text-slate-400 hover:text-blue-400">
                  <Pencil className="h-3.5 w-3.5 mr-1" /> Edit
                </Button>
                <Button variant="ghost" size="sm" onClick={() => onDelete(g.gratitude_id)} className="text-slate-400 hover:text-red-400">
                  <Trash2 className="h-3.5 w-3.5 mr-1" /> Delete
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
}
